var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddDocument(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.23 6.462H1a1 1 0 00-1 1V23a1 1 0 001 1h9.154v-7.385h7.384V14.77a8.273 8.273 0 01-8.307-8.307zM12 24l5.538-5.538H12V24zm5.538-24a6.422 6.422 0 00-6.461 6.462c0 3.6 2.861 6.461 6.461 6.461S24 10.062 24 6.462 21.138 0 17.538 0zm3.693 7.385h-2.77v2.769h-1.846v-2.77h-2.769V5.539h2.77V2.77h1.846v2.77h2.769v1.846z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddDocument);
export default ForwardRef;